"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showUserMessage = showUserMessage;
exports.toggleTroubleshootMode = toggleTroubleshootMode;

var _UserMessage = _interopRequireDefault(require("MeetingsLib/models/UserMessage"));

var ActionTypes = _interopRequireWildcard(require("MeetingsLib/redux/actions/ActionTypes"));

function showUserMessage(_ref) {
  var type = _ref.type,
      content = _ref.content;
  return {
    type: ActionTypes.SHOW_USER_MESSAGE,
    userMessage: (0, _UserMessage.default)({
      type: type,
      content: content
    })
  };
}

function toggleTroubleshootMode(active) {
  return {
    type: ActionTypes.TOGGLE_TROUBLESHOOT_MODE,
    active: active
  };
}